"use client"

import * as React from "react"
import { cn } from "@/lib/utils"

interface SkipLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href?: string
  children?: React.ReactNode
}

/**
 * Skip link component for keyboard navigation
 * Allows users to skip repetitive navigation and jump to main content
 * WCAG 2.4.1: Bypass Blocks
 */
function SkipLink({
  href = "#main-content",
  children = "Skip to main content",
  className,
  ...props
}: SkipLinkProps) {
  return (
    <a
      href={href}
      className={cn(
        // Visually hidden by default
        "sr-only",
        // Show on focus
        "focus:not-sr-only focus:absolute focus:z-[100] focus:top-4 focus:left-4",
        "focus:bg-background focus:text-foreground",
        "focus:px-4 focus:py-2 focus:rounded-md",
        "focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background",
        "focus:outline-none focus:shadow-lg",
        "font-medium text-sm",
        className
      )}
      {...props}
    >
      {children}
    </a>
  )
}

export { SkipLink }
